var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileSoundRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path855",
    d: "M0-682.665H14v14H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43224",
    "data-name": "Group 43224",
    transform: "translate(-10915 -13877)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16051",
    "data-name": "Rectangle 16051",
    width: 16,
    height: 16,
    transform: "translate(10915 13877)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g849",
    transform: "translate(10916 14560.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g851",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g853",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g859",
    transform: "translate(0.41 4.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path861",
    d: "M-187.412-203.029h-3.1a.82.82,0,0,1-.82-.82v-2.61a.82.82,0,0,1,.82-.82h3.1Z",
    transform: "translate(191.336 207.279)",
    fill: "#1564e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g863",
    transform: "translate(4.334 2.007)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path865",
    d: "M0-340.01l3.581,2.868v-9.987L0-344.26Z",
    transform: "translate(0 347.128)",
    fill: "#1564e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g867",
    transform: "translate(12.527 2.929)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path869",
    d: "M0-388.929A8.293,8.293,0,0,0,1.063-393,8.293,8.293,0,0,0,0-397.072",
    transform: "translate(0 397.072)",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g871",
    transform: "translate(11.044 4.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path873",
    d: "M0-277.334a6.447,6.447,0,0,0,.687-2.9,6.447,6.447,0,0,0-.687-2.9",
    transform: "translate(0 283.141)",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "g875",
    transform: "translate(9.543 5.28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path877",
    d: "M0-164.3a4.616,4.616,0,0,0,.33-1.72,4.615,4.615,0,0,0-.33-1.72",
    transform: "translate(0 167.744)",
    fill: "none",
    stroke: "#1564e8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSoundRecord);
export default __webpack_public_path__ + "static/media/file-sound-record.2a9b51747b2d9d889cd067a6a206c84a.svg";
export { ForwardRef as ReactComponent };